import { cn } from '@wwe-portal/ui/lib/lib';

export const SeperateLine = ({ className }: { className?: string }) => (
  <div
    className={cn('border-t-back300 border-0 border-t border-solid', className)}
  />
);
